import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import {
  DetalleProvisional, FormOperacionCLFB, schemaFormOperacionCLFB
} from "./types/types"

import { Box, Grid } from "@mui/material"
import { useCallback, useContext, useEffect, useState } from "react"
import toast from "react-hot-toast"

import { useLoader } from "src/hooks/useLoader"
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema"
import { HttpCLFB } from "./api/HttpCLFB"
import SeccionCLFBDatosAdicionales from "./components/SeccionCLFBDatosAdicionales"
import { SeccionCLFBDatosDetalleNuevo } from "./components/SeccionCLFBDatosDetalleNuevo"
import SeccionCLFBDatosOperacion from "./components/SeccionCLFBDatosOperacion"
import { OperacionCLFBFields } from "./types/fields"
import navigation from "src/navigation/vertical"
import { useSubmitOperacion } from "../../hooks/useSubmitOperacion"


type NuevoSistemaCLFBProps = {
  codSistemaPrincipal: number
}

export const NuevoSistemaCLFB = (props: NuevoSistemaCLFBProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const [detallesProvisionales, setDetallesProvisionales] = useState<DetalleProvisional[]>([])

  const formMethods = useForm<FormOperacionCLFB>({
    resolver: zodResolver(schemaFormOperacionCLFB),
    defaultValues: {
      [OperacionCLFBFields.FechaAprobacion]: new Date()
    }
  })

  const alCrearOperacionCLFB = useCallback((data: FormOperacionCLFB, selected: number) => {
    if (!detallesProvisionales.length) {
      toast.error('Debe cargar por lo menos una cuenta para enviar la operación.');
      
      return;
    }

    const payload = {
      ...data,
      [OperacionCLFBFields.ListaDetalles]: detallesProvisionales,
      [OperacionCLFBFields.BitEnvio]: selected !== 1,
      [OperacionCLFBFields.CodPais]: props.codSistemaPrincipal
    };

    submitOperacion(payload, {
      apiCall: HttpCLFB.post,
      successMessage: 'Guardado correctamente.',
    });
  }, [detallesProvisionales, props.codSistemaPrincipal, submitOperacion]);

  const { setSendPromise } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    const onSend = () => formMethods.handleSubmit(data => alCrearOperacionCLFB(data, 2))
    setSendPromise(onSend)
  }, [formMethods, alCrearOperacionCLFB])

  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SeccionCLFBDatosOperacion
            formMethods={formMethods}
            nuevo
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionCLFBDatosDetalleNuevo
            codPais={props.codSistemaPrincipal}
            detallesProvisionales={detallesProvisionales}
            setDetallesProvisionales={setDetallesProvisionales}
            adicionales={
              <SeccionCLFBDatosAdicionales
                formMethods={formMethods}
                codPais={props.codSistemaPrincipal}
              />
            }
          />
        </Grid>

      </Grid>
    </Box>
  )
}
